module.exports = __webpack_public_path__ + "static/lindenwood.074c64b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/lindenwood.png
// module id = 2187
// module chunks = 61762850755587